export { PaymentDocumentsRegistry } from './PaymentDocumentsRegistry.main';
